var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row body-main-row"
  }, [_c('div', {
    staticClass: "dashboard-new"
  }, [_c('div', {
    staticClass: "col-md-10 member-body-content-wrap pt-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xl-6 col-md-6 d-flex gap-2",
    staticStyle: {
      "text-align": "left"
    }
  }), _c('dashboard-enrollment-plan'), _c('div', {
    staticClass: "col-xl-8 col-lg-12"
  }, [_c('div', {
    staticClass: "dashboard-product-details"
  }, [_c('product-details', {
    ref: "productDetail",
    on: {
      "setPlanType": _vm.isMajorMedical,
      "tabType": _vm.checkBankingDetail
    }
  })], 1), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('message-center')], 1), _c('div', {
    staticClass: "col-md-6"
  }, [_c('resource')], 1), _c('div', {
    staticClass: "col-md-6"
  }, [_c('knowledge-center')], 1), _c('div', {
    staticClass: "col-md-6"
  }, [_c('beneficiary')], 1), _c('div', {
    staticClass: "col-md-6"
  }, [_c('employer')], 1), _c('div', {
    staticClass: "col-md-6"
  }, [_c('dependent')], 1)])]), _c('div', {
    staticClass: "col-xl-4 col-lg-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xl-12 col-lg-6 col-md-6 col-sm-12 dashboard-personal"
  }, [_c('personal-info')], 1), _c('div', {
    staticClass: "col-xl-12 col-lg-6 col-md-6 col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 dashboard-rep-info"
  }, [_c('rep-info')], 1)])])])])], 1)]), _c('div', {
    staticClass: "col-md-12 member-body-content-wrap member-body-content-wrap-bottom pt-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', [_vm.hasBankingAccess ? _c('banking-info') : _vm._e()], 1)]), _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', [_vm.employer_type != 'employer' ? _c('billing-invoice2') : _vm._e()], 1)])])]), _c('div')])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }